import Anchor from 'models/application/anchor/Anchor';

export default class ExternalAnchor extends Anchor {
	_category = 'external';
}
